import { useAxios } from "@hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useDeleteExamPeriod = () => {

    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { message } = App.useApp();

    const deleteExamPeriod = async (id: string) => {
        try {
            await axios.delete(`/api/examterms/${id}`);
        } catch (error) {
            throw new Error(t("messages.error.examPeriodDelete"));
        }
    };

    return useMutation({
        mutationFn: deleteExamPeriod,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["examPeriods"] });
            message.success(t("messages.success.deleteExamPeriod"));
        },
    });
}